export default {
  soon: {
    pt: 'A partir de {date}',
    en: 'Available from {date}',
    es: 'A partir de {date}',
  },
  closed: {
    pt: 'Encerrado',
    en: 'Closed',
    es: 'Cerrada',
  },
  soldOut: {
    pt: 'Esgotado',
    en: 'Sold out',
    es: 'Agotada',
  },
  free: {
    pt: 'Grátis',
    en: 'Free',
    es: 'Gratis',
  },
  nameCompanyName: {
    pt: 'Nome/razão social',
    en: 'Name/company name',
    es: 'Nombre/razón social',
  },
  email: {
    pt: 'E-mail',
    en: 'Email',
    es: 'Email',
  },
  phone: {
    pt: 'Telefone',
    en: 'Phone',
    es: 'Teléfono',
  },
  companyName: {
    pt: 'Nome da empresa',
    en: 'Company name',
    es: 'Nombre de la empresa',
  },
  jobTitle: {
    pt: 'Cargo',
    en: 'Job title',
    es: 'Cargo profesional',
  },
  document: {
    pt: 'CPF/CNPJ',
    en: 'CPF/CNPJ',
    es: 'CPF/CNPJ',
  },
  buyerData: {
    pt: 'Informações do comprador',
    en: 'Buyer information',
    es: 'Información del comprador',
  },
  attendeeData: {
    pt: 'Informações dos participantes',
    en: "Attendee's information",
    es: 'Informaciónes de los participantes',
  },
  ticketName: {
    pt: 'Ingresso {i, number}: {name}',
    en: 'Ticket {i, number}: {name}',
    es: 'Entrada {i, number}: {name}',
  },
  paymentData: {
    pt: 'Informações do pagamento',
    en: 'Payment information',
    es: 'Información de pago',
  },
  continue: {
    pt: 'Continuar',
    en: 'Continue',
    es: 'Continuar',
  },
  paymentForm: {
    pt: 'Forma de pagamento',
    en: 'Payment form',
    es: 'Forma de pago',
  },
  creditCard: {
    pt: 'Cartão de crédito',
    en: 'Credit card',
    es: 'Tarjeta de crédito',
  },
  bankSlip: {
    pt: 'Boleto bancário',
    en: 'Boleto',
    es: 'Boleto bancario',
  },
  bankSlipHint: {
    pt:
      'Ao finalizar a compra, o boleto bancário será gerado e você deverá realizar o pagamento em até 4 dias. Os ingressos serão enviados por e-mail assim que o pagamento for confirmado.',
    en:
      'After finishing, the payment document will be generated and you have up to 4 days to pay it. The tickets will be sent by email as soon as the payment is confirmed.',
    es:
      'Al finalizar la compra, el boleto bancario será generado y deberás realizar el pago en hasta 4 días. Las entradas serán enviadas por correo electrónico tan pronto como se confirme el pago.',
  },
  bankSlipRegistrationWarning: {
    pt:
      'O boleto pode levar até 2 horas para ser registrado no sistema bancário e estar liberado para pagamento em qualquer banco ou internet banking.',
    en:
      'The boleto may take up to 2 hours to be registered in the interbank system and available for payment in any bank or internet banking system.',
    es:
      'El boleto puede tardar hasta 2 horas en registrarse en el sistema interbancario y estar disponible para su pago en cualquier banco o sistema de internet banking.',
  },
  holderName: {
    pt: 'Nome impresso no cartão',
    en: 'Cardholder name',
    es: 'Nombre del titular de tarjeta',
  },
  ccNumber: {
    pt: 'Número do cartão de crédito',
    en: 'Card number',
    es: 'Número de tarjeta',
  },
  ccv: {
    pt: 'Código de segurança',
    en: 'Security code',
    es: 'Código de seguridad',
  },
  ccvHint: {
    pt:
      'São os três últimos dígitos impressos na barra de assinatura localizados no verso do seu cartão de crédito',
    en: 'The last three digits at the signature strip located on the back of your card',
    es:
      'Los tres últimos dígitos que se imprimen en la barra de firmas al dorso de tu tarjeta de crédito',
  },
  ccvAmexHint: {
    pt: 'São os quatro dígitos impressos acima do número do cartão',
    en: 'The four digits printed above your card number',
    es: 'Los cuatro dígitos que se imprimen encima del número de la tarjeta',
  },
  expiration: {
    pt: 'Data de validade',
    en: 'Expiration date',
    es: 'Fecha de vencimiento',
  },
  expirationPlaceholder: {
    pt: 'MM/AA',
    en: 'MM/YY',
    es: 'MM/AA',
  },
  billingAddress: {
    pt: 'Endereço de cobrança',
    en: 'Billing address',
    es: 'Dirección de facturación',
  },
  address: {
    pt: 'Endereço',
    en: 'Address',
    es: 'Dirección',
  },
  addressPostalCode: {
    pt: 'CEP',
    en: 'CEP',
    es: 'CEP',
  },
  addressForeignPostalCode: {
    pt: 'Código postal',
    en: 'Postal code',
    es: 'Código postal',
  },
  addressLine1: {
    pt: 'Logradouro',
    en: 'Street',
    es: 'Calle',
  },
  addressNumber: {
    pt: 'Número',
    en: 'Number',
    es: 'Número',
  },
  addressLine2: {
    pt: 'Complemento',
    en: 'Address complement',
    es: 'Complemento',
  },
  addressDistrict: {
    pt: 'Bairro',
    en: 'District',
    es: 'Barrio',
  },
  addressCity: {
    pt: 'Cidade',
    en: 'City',
    es: 'Ciudad',
  },
  addressState: {
    pt: 'Estado',
    en: 'State',
    es: 'Estado',
  },
  addressCountryCode: {
    pt: 'País',
    en: 'Country',
    es: 'País',
  },
  selectYourCountry: {
    pt: 'Selecione seu país',
    en: 'Select your country',
    es: 'Selecciona tu pais',
  },
  finishPayment: {
    pt: 'Finalizar compra',
    en: 'Finish payment',
    es: 'Finalizar pago',
  },
  paymentError: {
    pt:
      'Pagamento não realizado. Por favor revise seus dados de pagamento ou entre em contato com seu banco ou operadora de cartão de crédito.',
    en:
      'Payment failed. Please review your payment information or contact your bank or credit card operator.',
    es:
      'Pago no realizado. Por favor revise sus datos de pago o contacte a su banco o operador de tarjeta de crédito.',
  },
  creditCardConfirmationTitle: {
    pt: 'Seus ingressos estão garantidos',
    en: 'Your tickets are confirmed',
    es: 'Tus entradas están aseguradas',
  },
  bankSlipConfirmationTitle: {
    pt: 'Seus ingressos estão reservados até o pagamento',
    en: 'Your tickets are reserved until payment completion',
    es: 'Tus entradas están reservadas hasta el pago',
  },
  freeConfirmationMessage: {
    pt: 'Seus dados foram salvos e agora você já pode começar a se preparar para o evento.',
    en: 'Your data has been saved and you can start preparing for the event.',
    es: 'Tus datos se han guardado y ahora ya puedes empezar a prepararte para el evento.',
  },
  creditCardConfirmationMessage: {
    pt: 'Seu pagamento foi aprovado e você já pode começar a se preparar para o evento.',
    en: 'Your payment has been approved and you can start preparing for the event.',
    es: 'El pago fue aprobado y ya puedes preparate para el evento.',
  },
  bankSlipConfirmationMessage: {
    pt:
      'Agora, para que sua participação no evento seja confirmada, você precisa realizar o pagamento do boleto. Não perca o prazo: você tem até {bankSlipDueDate, date}.',
    en:
      "Now, for your tickets to be confirmed, you must pay using the attached document below. Don't miss the deadline: you have until {bankSlipDueDate, date}.",
    es:
      'Ahora, para que tu participación en el evento sea confirmada, necesitas realizar el pago del boleto bancario. No te pierdas en el plazo: tienes hasta el día {bankSlipDueDate, date}.',
  },
  printBankSlip: {
    pt: 'Imprimir boleto',
    en: 'Print payment document',
    es: 'Imprimir boleto bancario',
  },
  confirmationOrderTotal: {
    pt: 'Total do pedido:',
    en: 'Order total:',
    es: 'Total de la orden:',
  },
  creditCardConfirmationEmailSent: {
    pt: 'Enviamos um e-mail com o ingresso a todos os participantes inscritos.',
    en: 'We sent an email with the tickets to all registered participants.',
    es: 'Enviamos un correo electrónico con las entradas a todos los participantes registrados.',
  },
  bankSlipConfirmationDelayInstructions: {
    pt:
      'Se não for possível pagar imediatamente, aguarde algumas horas e tente novamente. Seu boleto pode levar até 2 horas para ser registrado no sistema bancário.',
    en:
      'If the payment is not immediately possible, please try again in a few hours. The boleto may take up to 2 hours to be registered in the banking system.',
    es:
      'Si el pago no es posible inmediatamente, espera algunas horas y inténtalo de nuevo. El boleto puede tardar hasta 2 horas para que sea registrado en el sistema bancario.',
  },
  bankSlipConfirmationEmailInstructions: {
    pt:
      'Após o pagamento, a confirmação ocorre em até 72 horas. Assim que o pagamento estiver confirmado, enviaremos um e-mail com o ingresso a todos os participantes inscritos.',
    en:
      'After the payment is done, the confirmation can take up to 72 hours. As soon as your payment is confirmed, we will send an email with the tickets to all registered attendees.',
    es:
      'La confirmación ocurre hasta 72 horas después del pago. Una vez que se apruebe el pago, enviaremos un correo electrónico con las entradas a todos los participantes registrados.',
  },
  bankSlipConfirmationDueInstructions: {
    pt: 'Caso não consiga fazer o pagamento até a data do vencimento, o pedido será cancelado.',
    en: 'If you are not able to pay until the expiration date, your order will be canceled.',
    es: 'Si no consigues hacer el pago hasta la fecha de vencimiento, la orden se cancelará.',
  },
  backToSite: {
    pt: 'Voltar para o site',
    en: 'Go back to the site',
    es: 'Volver al sitio',
  },
  loadingTicketTypes: {
    pt: 'Carregando ingressos...',
    en: 'Loading tickets...',
    es: 'Cargando entradas...',
  },
  emptyTicketTypes: {
    pt: 'Ingressos indisponíveis no momento. Por favor, tente mais tarde.',
    en: 'Tickets are unavailable at the moment. Please try again later.',
    es: 'Entradas no disponibles en ese momento. Por favor, inténtalo nuevamente más tarde.',
  },
  preOrderExpirationMessage: {
    pt: 'Seus ingressos estão reservados enquanto você completa os dados de inscrição.',
    en: 'Your tickets are safe while you fill in the registration data.',
    es: 'Tus entradas están reservadas mientras completas los datos de registro.',
  },
  preOrderExpiredTitle: {
    pt: 'O tempo para a compra expirou',
    en: 'The time for check out has ended',
    es: 'El tiempo para tu compra se ha acabado',
  },
  preOrderExpiredDescription: {
    pt:
      'Isso é necessário para que os ingressos não fiquem presos em uma reserva e possam estar disponíveis novamente.\n\nVocê pode recomeçar clicando no botão abaixo.',
    en:
      'This is important to prevent tickets from being stuck in a reservation and can be made available again.\n\nYou can restart by clicking the button below.',
    es:
      'Eso es necesario para que las entradas se bloqueen en una reserva y puedan estar disponibles de nuevo.\n\nPuedes volver al inicio haciendo clic en el botón abajo.',
  },
  preOrderExpiredButton: {
    pt: 'Recomeçar',
    en: 'Restart',
    es: 'Volver al inicio',
  },
  ticketsCount: {
    pt: `{ticketsCount, number} {ticketsCount, plural,
      one {ingresso}
      other {ingressos}
    }`,
    en: `{ticketsCount, number} {ticketsCount, plural,
      one {ticket}
      other {tickets}
    }`,
    es: `{ticketsCount, number} {ticketsCount, plural,
      one {entrada}
      other {entradas}
    }`,
  },
  freeTicket: {
    pt: 'Gratuito',
    en: 'Free',
    es: 'Gratis',
  },
  discountCouponSnackbarMessage: {
    pt: 'Você tem desconto exclusivo de {discount} na inscrição no evento. Garanta sua vaga aqui.',
    en:
      'You have an exclusive discount of {discount} for your registration in the event. Get your tickets now.',
    es:
      'Tienes un descuento exclusivo del {discount} para inscripción en el evento. Garantiza tus entradas aquí.',
  },
  couponBannerCode: {
    pt: 'Cupom {coupon}',
    en: 'Code {coupon}',
    es: 'Cupón {coupon}',
  },
  discountCouponBannerRule: {
    pt: '{discount} de desconto em ingressos selecionados{expiration}.{maxTickets}',
    en: '{discount} discount on selected tickets{expiration}.{maxTickets}',
    es: '{discount} de discuento en entradas seleccionadas{expiration}.{maxTickets}',
  },
  accessCouponBannerRule: {
    pt: 'Acesso a ingressos exclusivos{expiration}.{maxTickets}',
    en: 'Access to exclusive tickets{expiration}.{maxTickets}',
    es: 'Acceso a entradas exclusivas{expiration}.{maxTickets}',
  },
  accessAndDiscountCouponBannerRule: {
    pt: 'Acesso a ingressos exclusivos com {discount} de desconto{expiration}.{maxTickets}',
    en: 'Access to exclusive tickets with {discount} discount until{expiration}.{maxTickets}',
    es: 'Acceso a entradas exclusivas con {discount} de discuento hasta{expiration}.{maxTickets}',
  },
  couponBannerRuleExpiration: {
    pt: ' até {date, date, short}',
    en: ' until {date, date, short}',
    es: ' hasta {date, date, short}',
  },
  couponBannerRuleMaxTickets: {
    pt: ' Máximo de {max} ingressos.',
    en: ' Maximum of {max} tickets.',
    es: ' Máximo de {max} entradas.',
  },
  orderValidationError: {
    pt: 'Preencha corretamente os campos do formulário',
    en: 'Fill the form fields correctly',
    es: 'Rellena correctamente los campos del formulario',
  },
  orderSubmissionError: {
    pt: 'Ocorreu um erro ao enviar os dados formulário, verifique sua conexão e tente novamente',
    en: 'An error ocurred while submitting the form data, check your connection and try again',
    es:
      'Se produce un error al enviar los datos de formulario, comprueba tu conexión e inténtalo nuevamente',
  },
  chooseAnOption: {
    pt: 'Escolha uma opção',
    en: 'Choose an option',
    es: 'Elegir una opción',
  },
  fieldTakenError: {
    pt: '{field} já utilizado',
    en: '{field} already used',
    es: '{field} ya utilizado',
  },
  duplicatedFieldError: {
    pt: '{field} duplicado',
    en: '{field} duplicated',
    es: '{field} duplicado',
  },
  accessCouponSnackbarMessage: {
    pt: 'Você tem acesso a ingressos exclusivos. Garanta sua vaga aqui.',
    en: 'You have access to exclusive tickets. Get yours now.',
    es: 'Tienes acceso a entradas exclusivas. Garantiza las tuyas aquí.',
  },
  couponErrorSnackbarMessage: {
    pt: 'O link promocional usado não é válido ou o cupom já esgotou.',
    en: 'The promotional link used is invalid or the coupon has already sold out.',
    es: 'El enlace promocional utilizado no es válido o el cupón ya se ha agotado.',
  },
  installmentOptionLabel: {
    pt:
      '{installmentCount}x de {installmentValue} ({interest, select, 0% {sem juros} other {{interest} de juros}})',
    en:
      '{installmentCount}x {installmentValue} ({interest, select, 0% {interest-free} other {{interest} interest rate}})',
    es:
      '{installmentCount}x de {installmentValue} ({interest, select, 0% {sin interés} other {{interest} de interés}})',
  },
  credential: {
    pt: 'Credencial',
    en: 'Credential',
    es: 'Credencial',
  },
  barcode: {
    pt: 'Código de barras',
    en: 'Barcode',
    es: 'Código de barras',
  },
  installments: {
    pt: 'Parcelamento',
    en: 'Installments',
    es: 'Cuotas',
  },
  creditCardsAccepted: {
    pt: 'Cartões aceitos',
    en: 'Accepted cards',
    es: 'Tarjetas aceptadas',
  },
  iAmNotFromBrazil: {
    pt: 'Não sou brasileiro',
    en: 'I’m not from Brazil',
    es: 'No soy brasileño',
  },
  idNumber: {
    pt: 'Número de identidade',
    en: 'ID number',
    es: 'Num de identificación',
  },
  idNumberTip: {
    pt: 'Documento de identidade / Número de registro da empresa',
    en: 'National ID / Tax ID',
    es: 'Documento de identidad / número de registro de la empresa',
  },
  usePromoCode: {
    pt: 'Usar cupom promocional',
    en: 'Use promo code',
    es: 'Utilizar cupón promocional',
  },
  promotionalCoupon: {
    pt: 'Cupom promocional',
    en: 'Promotional coupon',
    es: 'Cupón promocional',
  },
  pasteYourCodeHere: {
    pt: 'Cole o código aqui',
    en: 'Paste your code here',
    es: 'Pega el código aquí',
  },
  apply: {
    pt: 'Aplicar',
    en: 'Apply',
    es: 'Aplicar',
  },
  couponGeneralError: {
    pt: 'O código usado não é válido ou o cupom já esgotou.',
    en: 'The code used is invalid or the coupon has already sold out.',
    es: 'El código utilizado no es válido o el cupón ya se ha agotado.',
  },
  couponMaxTicketsError: {
    pt:
      'Para aplicar este cupom você deve ter no máximo {maxTicketsByCoupon} ingressos selecionados.',
    en: 'To apply this coupon you must have a maximum of {maxTicketsByCoupon} tickets selected.',
    es:
      'Para aplicar ese cupón debes tener un máximo de {maxTicketsByCoupon} entradas seleccionadas.',
  },
};



// WEBPACK FOOTER //
// ./src/intl/messages/registerExtension.js